import Vue from 'vue'

export const state = {
  expandedVehicleIds: {}, // List of expanded vehicle id's
  selectedVehicleId: null, // The currently selected vehicle
  expandedUnitIds: {}, // List of expanded unit id's
  selectedUnitId: null, // The currently selected unit
  selectedAsset: null // Either null, or something like { type: 'vehicle', id: 1 } or { type: 'unit', id: 1 }
}

export const getters = {
  /**
   * Returns the full state object
   *
   * @param state Object
   *
   * @return Object
   */
  get (state) {
    return state
  },

  /**
   * Returns all the expanded vehicle id's
   *
   * @param state
   *
   * @returns Object
   */
  expandedVehicleIds (state) {
    return state.expandedVehicleIds
  },

  /**
   * Returns the currently selected vehicle's id
   *
   * @param state
   *
   * @returns Int|null
   */
  selectedVehicleId (state) {
    return state.selectedVehicleId
  },

  /**
   * Returns all the expanded unit id's
   *
   * @param state
   *
   * @returns Object
   */
  expandedUnitIds (state) {
    return state.expandedUnitIds
  },

  /**
   * Returns the currently selected unit's id
   *
   * @param state
   *
   * @returns Int|null
   */
  selectedUnitId (state) {
    return state.selectedUnitId
  },

  /**
   * Returns the currently selected asset type and id in the format:
   * { type: 'vehicle', id: 1 } or
   * { type: 'unit', id: 1 }
   *
   * @param state
   *
   * @returns Object|null
   */
  selectedAsset (state) {
    return state.selectedAsset
  }
}

export const mutations = {
  /**
   * Expands the specific vehicle.
   *
   * @param state
   * @param vehicleId
   */
  expandVehicle (state, vehicleId) {
    Vue.set(state.expandedVehicleIds, vehicleId, true)
  },

  /**
   * En-expands the specific vehicle.
   *
   * @param state
   * @param vehicleId
   */
  unExpandVehicle (state, vehicleId) {
    Vue.delete(state.expandedVehicleIds, vehicleId)
  },

  /**
   * Selects the specific vehicle, set to null to
   * clear selection.
   *
   * @param state
   * @param vehicleId int|null
   */
  selectVehicle (state, vehicleId) {
    state.selectedUnitId = null
    state.selectedVehicleId = vehicleId
    state.selectedAsset = { type: 'vehicle', id: vehicleId }
  },

  /**
   * Expands the specific unit.
   *
   * @param state
   * @param unitId
   */
  expandUnit (state, unitId) {
    Vue.set(state.expandedUnitIds, unitId, true)
  },

  /**
   * En-expands the specific unit.
   *
   * @param state
   * @param unitId
   */
  unExpandUnit (state, unitId) {
    Vue.delete(state.expandedUnitIds, unitId)
  },

  /**
   * Selects the specific unit, set to null to
   * clear selection.
   *
   * @param state
   * @param unitId int|null
   */
  selectUnit (state, unitId) {
    state.selectedVehicleId = null
    state.selectedUnitId = unitId
    state.selectedAsset = { type: 'unit', id: unitId }
  },

  /**
   * Resets the live tracking state.
   *
   * @param state
   */
  purge (state) {
    state.expandedVehicleIds = {}
    state.selectedVehicleId = null
    state.expandedUnitIds = {}
    state.selectedUnitId = null
    state.selectedAsset = null
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/monitoring/liveTrackingWidgetModule.js